var unitab = {
    init: function() {
        var self = this;

		var counter = 0;
        jQuery( '.unitabs__link' ).each(function( item ){
			var target = jQuery( this ).attr( 'data-target' );
			var isTarget = jQuery( `section.${target}` );

			isTarget.attr( 'data-is-target', target );

			if( counter > 0 ) {
				isTarget.addClass( 'hidden' );
			} else {
				jQuery( this ).addClass( 'active' );
			}

			counter++;
		});
    
		jQuery( document ).on( 'click', '.unitabs__link', function( event ){
			event.preventDefault();

			if( jQuery( this ).hasClass( 'active' ) ) {
				return;
			}

			jQuery( '.unitabs__link.active' ).addClass('prev-active');
			jQuery( this ).addClass( 'active' );

			var target = jQuery( this ).attr( 'data-target' );

			jQuery( `[data-is-target].${target}` ).removeClass( 'hidden' );
			jQuery( `[data-is-target]:not( .${target} )` ).addClass( 'hidden' );

			setTimeout(function(){
				jQuery( '.unitabs__link.prev-active' ).removeClass('active');
				jQuery( '.unitabs__link.prev-active' ).removeClass('prev-active');
			}, 251 );
		});
	}
}

export {
    unitab
};
